import { getAugmentedNamespace } from './_commonjsHelpers.js';
import * as index from '../node_modules/date-fns/esm/isEqual/index.js';

var require$$48 = /*@__PURE__*/getAugmentedNamespace(index);

export { require$$48 as default };
